const invertedMessages = {
  'External identities': 'external.dashboard.identities.externalIdentities',
  'External Identities based on classification rules':
    'external.dashboard.identities.count.tooltip',
  'This section presents the distribution of external identities based on employee type.':
    'external.dashboard.identities.info.tooltip',
  Others: 'external.dashboard.identities.others',
  UNSPECIFIED: 'external.dashboard.identities.type.unspecified',
  Contractor: 'external.dashboard.identities.type.contractor',
  Supplier: 'external.dashboard.identities.type.supplier',
  'Document User': 'external.dashboard.identities.type.documentUser',
  'Full-time': 'external.dashboard.identities.type.fullTime',
  TEMP: 'external.dashboard.identities.type.temp',
  Permanent: 'external.dashboard.identities.type.permanent',
};

export default invertedMessages;
